import React, { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import CustomCard from '../../shared/CustomCard';
import { bottomSheetMenuList } from '../constants';

const useStyles = makeStyles(() => ({
  bottomSheet: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    background: 'white',
    boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.3)',
    transition: 'transform 0.3s ease-in-out',
    transform: 'translateY(100%)',
    zIndex: 1000,
    maxHeight: '55%',
    minHeight: '180px',
    overflow: 'auto',
  },
  bottomSheetContent: {
    padding: '20px',
  },
  closeBtn: {
    cursor: 'pointer',
  },
  open: {
    transform: 'translateY(0)',
  },
  heading: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16.08px',
    color: 'rgba(98, 47, 238, 1)',
  },
}));
const DealershipBottomSheet = ({ isOpen, onClose, data, handleRemove, selectAllMode, totalCount, displaySelectedCount }) => {
  const classes = useStyles();
  const [selectedRoles, setSelectedRoles] = useState([]);
  const dealershipsAll = useSelector((state) => state.GetDealershipList.dealershiplist);

  useEffect(() => {
    if (selectAllMode) return;
    const selectedIds = _map(data, (id) => Number.parseInt(id, 10));
    setSelectedRoles(_filter(dealershipsAll, (d) => _includes(selectedIds, d.id)));
  }, [data, dealershipsAll, selectAllMode]);

  if (!isOpen) return null;

  const heading = `${selectAllMode ? totalCount : (displaySelectedCount ?? data?.length ?? 0)} Dealerships selected`;

  return (
    <div className={`${classes.bottomSheet} ${classes.open}`}>
      <div className={classes.bottomSheetContent}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Grid container direction="row" alignItems="center" className={classes.mainContainer}>
              <Grid item xs>
                <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
                  <Grid item className={classes.heading}>
                    {heading}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Close className={classes.closeBtn} onClick={onClose} />
              </Grid>
            </Grid>
          </Grid>
          {selectAllMode ? null : (
            <Grid
              container
              direction="row"
              className={classes.roleMainBox}
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              {selectedRoles?.map((role) => (
                <Grid item key={role.id} className={classes.box}>
                  <CustomCard
                    id={role?.id}
                    checkbox={false}
                    menu
                    title={role?.name}
                    width="321px"
                    height="44px"
                    handleMenuItemClick={handleRemove}
                    menuItems={bottomSheetMenuList}
                    name="dealerships"
                    grey
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default DealershipBottomSheet;
